@switch ($brand()) {
@case ('gm') {
<app-icon icon="gm-logo" size="49px 48px" [scale]="$scale()" color="original" class="relative top-[3.5px]" />
}
@case('kia') {
<app-icon icon="kia-logo" [scale]=".45 * $scale()" color="--black-white" class="relative top-[3.5px]" />
}
@default {
<app-icon icon="seekop-logo" [scale]=".1 * $scale()" color="--logo" class="relative top-[3.5px]" />
}}
